export type CourseTypeId = 'fc' | 'ca' | 'm1' | 'special-foundation'

export const courseTypes: {
  id: CourseTypeId
  title: string
}[] = [
  {
    id: 'm1',
    title: 'M1'
  },
  {
    id: 'special-foundation',
    title: 'Special Foundation'
  },
  {
    id: 'fc',
    title: 'Foundation Certificate'
  },
  {
    id: 'ca',
    title: 'Certified Associate'
  }
]
